(function () {
  var MIN_CENTS = 20000; // $200.00
  var cartCache = { cents: null, ts: 0 };
  var inflight = null;

  function isWholesaleApproved() {
    // Any wholesale note present with enabled=true means this customer is tagged.
    var note = document.querySelector('[data-wholesale-minimum-note][data-wholesale-enabled="true"]');
    return !!note;
  }

  function getTargets() {
    var notes = Array.from(document.querySelectorAll('[data-wholesale-minimum-note][data-wholesale-enabled="true"]'));
    var btns  = Array.from(document.querySelectorAll('[data-wholesale-checkout]'));
    return { notes: notes, btns: btns };
  }

  function enableBtn(btn) {
    btn.removeAttribute('disabled');
    btn.removeAttribute('aria-disabled');
    btn.classList.remove('disabled', 'is-disabled');
    btn.style.pointerEvents = '';
    btn.style.opacity = '';
  }

  function disableBtn(btn) {
    // Keep it simple: real disable for buttons
    if (btn.tagName === 'BUTTON') btn.setAttribute('disabled', 'disabled');
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-disabled');
  }

  function applyState(blocked) {
    var t = getTargets();

    // If the quick cart hasn't been inserted yet, nothing to do (we'll run again on mutations)
    if (!t.notes.length && !t.btns.length) return;

    t.btns.forEach(function (btn) {
      // Always reset first so we "win" against other scripts
      enableBtn(btn);
      if (blocked) disableBtn(btn);
    });

    t.notes.forEach(function (note) {
      if (blocked) note.classList.remove('is-hidden');
      else note.classList.add('is-hidden');
    });
  }

  async function fetchCartCents() {
    // Tiny cache so we don't spam /cart.js during rapid quantity taps
    var now = Date.now();
    if (cartCache.cents !== null && (now - cartCache.ts) < 400) return cartCache.cents;

    if (inflight) return inflight;

    inflight = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Match your displayed subtotal logic (you chose total_price)
        cartCache.cents = cart.total_price;
        cartCache.ts = Date.now();
        inflight = null;
        return cartCache.cents;
      })
      .catch(function () {
        inflight = null;
        // fail open
        return null;
      });

    return inflight;
  }

  async function refresh(reason) {
    // Only apply rules for wholesale-approved users
    if (!isWholesaleApproved()) {
      applyState(false);
      return;
    }

    var cents = await fetchCartCents();
    if (cents === null) {
      // fail open
      applyState(false);
      return;
    }

    applyState(cents < MIN_CENTS);
  }

  // 1) Initial run
  document.addEventListener('DOMContentLoaded', function () {
    refresh('DOMContentLoaded');
  });

  // 2) Watch for the quick-cart being injected / replaced (AJAX)
  var obs = new MutationObserver(function () {
    // Debounce-ish by using the cartCache window above
    refresh('MutationObserver');
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // 3) Hook into fetch & XHR so ANY cart update triggers refresh immediately
  // (This makes it instant even before the DOM mutation happens)
  var origFetch = window.fetch;
  window.fetch = function () {
    var p = origFetch.apply(this, arguments);
    try {
      var url = (arguments[0] && arguments[0].url) ? arguments[0].url : arguments[0];
      url = String(url || '');
      if (url.includes('/cart') || url.includes('cart')) {
        p.finally(function () { refresh('fetch'); });
      }
    } catch (e) {}
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._isCartReq = String(url || '').includes('/cart') || String(url || '').includes('cart');
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._isCartReq) {
      this.addEventListener('loadend', function () { refresh('xhr'); });
    }
    return origSend.apply(this, arguments);
  };
})();